// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__sISg0","inputWrap":"Table_inputWrap__2nept","col":"Table_col__5KwbT","bmiTooltip":"Table_bmiTooltip__2Qw7s"};